import React from 'react';
import PropTypes from 'prop-types';

const defaultFields = ['H1', 'L1', 'H2', 'L2'];

class MeasurementsCurvedA extends React.Component {
  state = {
    fields: defaultFields,
  };

  componentDidMount() {
    this.validate();
  }

  componentWillUnmount() {
    if (this.props.errors.lengths) {
      this.props.setError('lengths');
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (['ur', 'ul'].includes(props.values.stair_type) && !state.fields.includes('H3')) {
      return {
        fields: [
          ...state.fields,
          'H3',
          'L3',
        ],
      };
    }

    if (state.fields.length === 4) {
      return null;      
    }

    return defaultFields;  
  }

  validate() {
    const { lengths = {} } = this.props.values;
    let error = '';

    this.state.fields.forEach((field) => {
      if (!error && !lengths[field] && this.props.values.removed_part !== field) {
        error = 'required';
      }
    });

    if (!lengths.gg) {
      error = 'required';
    }

    this.props.setError('lengths', error);
  }

  setLengthValue(name, length) {
    const { lengths = {} } = this.props.values;

    lengths[name] = parseInt(length, 10) || 0;

    const lengthKeys = Object.keys(lengths).filter((key) => key.indexOf('L') === 0);

    this.props.setValue('lengths', lengths);
    this.props.setValue('total_length', lengthKeys.reduce((a, b) => a + lengths[b], 0));

    setTimeout(() => this.validate(), 50);
  }

  handleLengthChange = (e) => {
    this.setLengthValue(e.target.name, e.target.value);
  };

  handleRemoveToggle = (e) => {
    const { target } = e;

    this.props.setValue('removed_part', target.checked ? target.value : '');

    let bendQuantity = this.props.values.stair_type.indexOf('u') === 0 ? 2 : 1;

    if (target.checked) {
      bendQuantity -= 1;
    }

    if (this.props.values.corner_bend_price) {
      this.props.setValue('extras', {
        ...this.props.values.extras,
        corner_bend: this.props.values.corner_bend_price * bendQuantity,
      });
    }

    if (target.checked) {
      this.setLengthValue(target.value, 0);
    } else {
      setTimeout(() => this.validate(), 50);
    }
  };

  render() {
    const {
      instructions: {
        curved: instructions = {}
      }
    } = window.MTMReact;

    const {
      lengths = {},
      stair_type,
      removed_part,
    } = this.props.values;

    const lStair = stair_type.indexOf('l') === 0;

    return (
      <React.Fragment>
        <div className="mtm-instructions" dangerouslySetInnerHTML={{ __html: instructions.measurements[stair_type] }} />

        <h3 className="mtm-step-title-sub">Mått vinkelsvängd ledstång</h3>

        <div className="row small-up-2">
          {this.state.fields.map((name) => {
            const removed = removed_part === name;
            const field = (
              <input
                type="number"
                min="1"
                name={name}
                id={name}
                value={lengths[name] || ''}
                onChange={this.handleLengthChange}
                disabled={removed}
              />
            );

            return (
              <div key={name} className="column">
                <label htmlFor={name}>{name} (mått i mm)</label>

                {name === 'L1' || (lStair && name === 'L2') || name === 'L3' ? (
                  <div className="row removable-part">
                    <div className="column medium-11">
                      {field}
                    </div>

                    <div className="column medium-5">
                      <label>
                        <input type="checkbox" name="remove" value={name} onChange={this.handleRemoveToggle} checked={removed} />
                        <small>Ta bort sektion {name}</small>
                      </label>
                    </div>
                  </div>
                ) : (
                  field
                )}
              </div>
            );
          })}
        </div>

        <div className="mtm-instructions" dangerouslySetInnerHTML={{ __html: instructions.floor_to_floor }} />
        
        <h3 className="mtm-step-title-sub">Mått golv till golv</h3>

        <label>
          GG (mått i mm)
          <input type="number" min="1" name="gg" value={lengths.gg || ''} onChange={this.handleLengthChange} />
        </label>
      </React.Fragment>
    );
  }
}

MeasurementsCurvedA.propTypes = {
  values: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
};

export default MeasurementsCurvedA;





// WEBPACK FOOTER //
// ./src/Step/steps/MeasurementsCurvedA.js